import {Controller} from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    this.element.addEventListener('click', () => {
      document
        .querySelectorAll('.datepicker-modal.open')
        .forEach(modal => modal.style.display = "none"); // hide before animation starts... otherwise: datepicker jumps

      setTimeout(() => {
        const modals = document.querySelectorAll('.datepicker-modal.open');
        modals.forEach(modal => {
          modal.style.display = "block"
          modal.style.setProperty('top', '20%', 'important');

          if (modal.parentElement.tagName !== 'BODY') {
            document.body.appendChild(modal);
          }
        });
      }, 300); // have to wait until animation is ended... otherwise the css top property is overridden by materializecss
    });
  }
}